import { ReactNode } from 'react'

import styles from '@/pages/app/BillingOps/styles.module.scss'

import { ENGINEERING_ONLY_KINDS, NoInput } from '@/pages/app/BillingOps/types'

interface NoInputFormProps {
  kind: string
  formId: string
  onSubmit: (input: NoInput) => void
  children: ReactNode
}

const NoInputForm = ({ kind, formId, onSubmit, children }: NoInputFormProps) => (
  <form
    id={formId}
    onSubmit={(e) => {
      e.preventDefault()
      onSubmit({})
    }}
    className={styles.section}
  >
    {ENGINEERING_ONLY_KINDS.has(kind) && (
      <div className={styles.errorBanner}>
        <strong>Engineering only. Support: do not run this.</strong> It switches which billing system charges this org.
        If a customer asks about it, hand it to the billing engineers.
      </div>
    )}
    <p className={styles.helperText}>{children}</p>
  </form>
)

export default NoInputForm
